import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const Block = styled.div`
  width: 100%;
`;

export const ColorPickerRow = styled.section`
  display: flex;
  align-items: center;
  margin-top: 15px;
  gap: 5px;

  & .react-colorful {
    width: auto;
    height: 115px;
  }
  & .react-colorful__hue {
    width: auto;
    height: 15px;
  }
  & .react-colorful__saturation-pointer,
  & .react-colorful__hue-pointer,
  & .react-colorful__alpha-pointer {
    width: 20px;
    height: 20px;
  }
`;

export const BackgroundPreview = styled.span.attrs(({ backgroundColor }) => ({
  style: { background: backgroundColor },
}))`
  display: block;
  width: 100%;
  height: 68px;
  padding: 0.375rem 0.75rem;
  border: 1px solid ${colors.borderGray};
  border-radius: 8px;
  margin-top: 0.5rem;
`;

export const LandingPageImage = styled.img`
  margin-top: 0.5rem;
  max-height: 450px !important;
  max-width: 100% !important;
`;

export const GraphicsImagesContainer = styled.div`
  padding-top: 5px;
`;

export const GraphicsImageRow = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  border-bottom: 1px solid ${colors.borderGray};
`;

export const GraphicsImageCell = styled.div`
  padding: 5px 0px 5px 0px;
  ${({ overflowHidden }) =>
    overflowHidden &&
    css`
      overflow: hidden;
    `}
  ${({ push }) =>
    push &&
    css`
      margin-left: auto;
    `}
`;

export const GraphicsImage = styled.img`
  max-height: 2em;
  max-width: 5em;
`;

export const ModalInput = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-top: 0.75rem;
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;
